import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import {
  GetIntegrationCompanyResponse,
  GetIntegrationConfigListResponse,
  GetIntegrationRecordTypeResponse,
} from '../services/integration-service';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/integrations/companies'), () => {
    return HttpResponse.json<GetIntegrationCompanyResponse>({
      page: 0,
      rows: 10,
      next: false,
      results: [],
    });
  }),
  http.get(mockTruktTmsApiUrl('/integrations/record-types'), () => {
    return HttpResponse.json<GetIntegrationRecordTypeResponse>({
      next: false,
      page: 0,
      results: [],
      rows: 10,
    });
  }),

  http.get(mockTruktTmsApiUrl('/integrations/:appId/configs'), () => {
    return HttpResponse.json<GetIntegrationConfigListResponse>([]);
  }),
];
